// NOTE: 사용 필요 의문
export const API_ERROR_CODE = {
  ACCESS_TOKEN_MALFORMED: '3000',
  ACCESS_TOKEN_EXPIRED: '3001',
};

export const WEBSOCKET_CONFIG = {
  RECONNECT_DELAY: 1_000,
  HEARTBEAT_INCOMING: 1_000 * 1, // 현재 서버에서는 이 값과 무관하게 60초로 자름.
  HEARTBEAT_OUTGOING: 1_000 * 1,
};
